export default __webpack_public_path__ + "static/media/middle-board.c5c95f89.svg";